module.exports = __webpack_public_path__ + "img/komuni.4cdb26d8.png";